// removed by extract-text-webpack-plugin
module.exports = {"addGroupContainer":"_3CaKRNXPuDkWvgPiFy2nl9","top":"_2hCcFOaBfpYxJbcFxygjWd","title":"HcNMq2YYZ61U6Fy3nZD70","searchContainer":"_1pw-fOruWjgwIDxP6uzO66","tabsContainer":"_3r2WmhW6pPydim5EfGVK3x","btnContainer":"_3y0PcokYfJlcsaZdO9JpmF","btn":"_3swHDN6zlqAjwbsTY6qaZx"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/DeviceGroup/AddGroup.less
// module id = 1635
// module chunks = 0